import { createFileRoute } from '@tanstack/react-router';
import { Changelog } from '@/features/system/Changelog';

export const Route = createFileRoute('/_app/changelog')({ component: Changelog });
